import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const feedLines = [
  { prefix: '000', type: 'INTENT', body: 'score=0.92 sku=SGS24-ULTRA dwell=47s', color: 'text-[#60a5fa]' },
  { prefix: '001', type: 'DCO', body: 'variant B served · lang=de · creative#731', color: 'text-[#60a5fa]' },
  { prefix: '002', type: 'CONVERT', body: 'order=#A-8812 rev=€1,349 CPS=€47', color: 'text-[#ff5117]' },
  { prefix: '003', type: 'INTENT', body: 'score=0.87 sku=MONDLY-PRO cart=true', color: 'text-[#60a5fa]' },
  { prefix: '004', type: 'BID', body: 'win $0.88 inv=TTD geo=US cpm=$2.91', color: 'text-[#22d07a]' },
  { prefix: '005', type: 'DCO', body: 'variant A served · lang=es · creative#219', color: 'text-[#60a5fa]' },
  { prefix: '006', type: 'CONVERT', body: 'order=#B-1134 rev=$249 CPS=$8.7', color: 'text-[#ff5117]' },
  { prefix: '007', type: 'INTENT', body: 'score=0.71 sku=PHIL-AVENT dwell=22s', color: 'text-[#60a5fa]' },
];

function formatTime(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}Z`;
}

export default function HeroSection() {
  const [visibleLines, setVisibleLines] = useState(feedLines.slice(0, 4));
  const [time, setTime] = useState(formatTime(new Date()));

  useEffect(() => {
    const t = setInterval(() => setTime(formatTime(new Date())), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    let i = 4;
    const t = setInterval(() => {
      setVisibleLines((prev) => {
        const next = [...prev, feedLines[i % feedLines.length]];
        i += 1;
        return next.slice(-6);
      });
    }, 2500);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative overflow-hidden hero-grid diag-lines min-h-[92vh] flex items-center" data-testid="hero-section">
      <div className="container-r360 relative z-10 heroSec">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="highlights-kicker text-blue">
            <span />
            Enterprise Retargeting platform
          </div>
            <h1 className="font-display font-bold leading-[0.92] tracking-[-0.035em] text-[4rem] md:text-[4.75rem] lg:text-[5.75rem] xl:text-[7rem]">
              <span className="block">WIN BACK</span>
              <span className="block accent">EVERY</span>
              <span className="block">LOST SALE.</span>
            </h1>
            <p className="mt-6 text-[17px] leading-relaxed text-[#c9c9c9] max-w-xl font-bold">
              The only enterprise retargeting platform that charges you <span className="italic text-white">nothing</span> until a verified sale occurs. Zero wasted ad spend. Zero risk. Maximum ROAS.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/book-a-demo" className="btn btn-primary" data-testid="hero-cta-book">
                Book a strategy call →
              </Link>
              <a href="#calculator" className="btn btn-outline" data-testid="hero-cta-calc">
                Try the ROAS calculator
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-black/80 border border-[#1a1a1a] p-6 font-mono text-[13px] min-h-[380px]" data-testid="live-feed">
              <div className="flex items-center justify-between mb-6 text-[#8a8a8a]">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-[#ff5117] inline-block"></span>
                  <span>R360.LIVE // BIDDING FEED</span>
                </div>
                <span>{time}</span>
              </div>
              <div className="space-y-3">
                {visibleLines.map((l, idx) => (
                  <div key={idx} className="flex gap-3">
                    <span className="text-[#5a5a5a]">{l.prefix}</span>
                    <span className={l.color}>
                      <span className="font-bold">{l.type}:</span> {l.body}
                    </span>
                  </div>
                ))}
                <div className="text-[#ff5117] cursor-blink">&gt;</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-4 border-y border-[#5a5a5a] mt-10 lg:mt-15 xl:mt-20">
          {[
            { k: '97%', v: 'VISITORS LEAVE WITHOUT BUYING' },
            { k: '22×', v: 'AVERAGE ROAS DELIVERED' },
            { k: '$260B', v: 'RECOVERABLE CART REVENUE' },
            { k: 'CPS', v: 'YOU ONLY PAY PER SALE' },
          ].map((s, i) => (
            <div key={i} className="p-4 lg:p-6 border-x border-[#5a5a5a] border-y">
              <div
                className={`font-display text-[2.5rem] lg:text-[4rem] leading-none font-black ${
                  (i + 1) % 2 === 0 ? 'text-[var(--color-blue)]' : ''
                }`}
              >
                {s.k}
              </div>
              <div className="mono-label mt-3 text-white">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
